<template>
  <div>
    <modal class="modal-content" @close="$emit('close')">   

        <div v-if="team.isTrial" slot="msg" class="message">
          {{ updateTrialText(daysLeft) }}
          <a @click="linktoUpgradeOptions()">{{ $t('duringthetrialLink') }}</a
          >.
        </div>    
      
      <h4 slot="title">
        
        <div v-if="showStages" class="steps">
          <div :class="number1Class">1</div>
          <div :class="number2Class">2</div>
        </div>
        {{ title }}
      </h4>

      <section slot="body" class="body">        
        <div v-if="mode === 'connect-clavo-to-integration'" class="integration-connect-users">
          <div>
            <label>CLAVO</label>
            <member-name-box :member="memberFrom" hide-avatar class="connect"></member-name-box>
          </div>
          <div>
            <label>{{ system }}</label>
            <member-name-box v-if="memberTo" :member="memberTo" hide-avatar></member-name-box>
          </div>
        </div>

        <div v-else class="description">
          <div v-if="subtitle1" class="subtitle1">{{ subtitle1 }}</div>
          <div v-if="subtitle2" class="subtitle2">{{ subtitle2 }}</div>
        </div>

        <invitation-form
          class="invite-form"
          :modal="true"
          :team="team"
          :team-id="team.teamId"
          :mode="mode"
          :members="members"
          :member-from="memberFrom"
          :system="system"
          :show-illustration="showIllustration"
          @sync-slack="isSlack = true"
          @continue="$emit('continue')"
          @connect="member => $emit('connect', member)"
          @disconnect="member => $emit('disconnect', member)"
          @disconnected="member => $emit('disconnected', member)"
          @member-selected="member => (memberTo = member)"
          @sync-without-slack="isSlack = false"
          @done="done"
          @close="$emit('close')"
        />
    
      </section>
    </modal>
  </div>
</template>

<script>
import EventBus from '@/EventBus'
import Modal from '@/components/Modal'
import Constants from '@/components/Constants'
import Parse from 'parse'
import InvitationForm from '@/components/Team/InvitationForm'
import moment from 'moment-timezone'
import ParseFunctions from '@/components/ParseFunctions'
import MemberNameBox from '@/components/Team/MemberNameBox'

export default {
  components: {
    Modal,
    InvitationForm,
    MemberNameBox,
  },
  mixins: [Constants, ParseFunctions],
  props: {
    team: { type: Object, default: undefined },
    mode: { type: String, default: 'invite' },
    system: { type: String, default: 'invite' },
    members: { type: Array, default: undefined },
    matchedUsersCount: { type: Number, default: null },
    memberFrom: { type: Object, default: undefined },
    showIllustration: { type: Boolean, default: false },
  },
  data() {
    return {
      emails: ['', '', ''],
      emailValid: [],
      daysLeft: 0,
      isSlack: false,
      title: '',
      subtitle1: '',
      subtitle2: '',
      number1Highlight: false,
      number2Highlight: false,
      memberTo: undefined,
    }
  },
  computed: {
    showStages() {
      return this.mode === 'clavo-not-in-integration' || this.mode === 'integration-not-in-clavo'
    },
    number1Class() {
      return {
        'text-blue': this.number1Highlight,
        'text-faded': !this.number1Highlight,
      }
    },
    number2Class() {
      return {
        'text-blue': this.number2Highlight,
        'text-faded': !this.number2Highlight,
      }
    },
  },
  watch: {
    mode: function() {
      this.setTitlesForMode()
    },
    matchedUsersCount: function() {
      this.setTitlesForMode()
    },
  },
  created() {
    this.daysLeft = moment(this.team.validUntil).diff(moment(), 'days')
    this.setTitlesForMode()
  },
  methods: {
    validateEmails() {
      let allValid = true
      let allEmpty = true
      for (let i = 0; i < this.emails.length; i++) {
        if (this.emails[i] !== '') allEmpty = false
        let valid = this.emails[i] === '' || this.emailValid(this.emails[i])
        this.$set(this.emailValid, i, valid)
        allValid = allValid && valid
      }

      this.allValid = allValid && !allEmpty
      // console.log(this.emailValid, this.allValid)
    },
    addEmail() {
      this.emails.push('')
      this.validateEmails()
    },
    getIntegrationFormalName(system) {
      if (system === 'teams') {
        return 'Microsoft Teams'
      } else {
        return system[0].toUpperCase() + system.substring(1)
      }
    },
    setTitlesForMode() {
      let system = this.getIntegrationFormalName(this.system)
      let number = this.matchedUsersCount
      if (this.mode === 'invite') {
        this.title = this.isSlack ? this.$t('syncWithSlack') : this.$t('invitePeople')
        this.subtitle1 = this.$t('subscriptionChargedPerMember')
        this.subtitle2 = ''
      } else if (this.mode === 'clavo-not-in-integration') {
        this.title = this.$t('integrateUsersTitle', { system })
        this.subtitle1 = number == null ? '' : this.$tc('integrateUsersSubtitle1', (number == 0 || number > 1) ? 0 : 1, { number })
        this.subtitle2 = this.members.length > 0 ? this.$t('integrateUsersSubtitle2', { system }) : ''
        this.number1Highlight = true
        this.number2Highlight = false
      } else if (this.mode === 'integration-not-in-clavo') {
        this.title = this.$t('integrateUsersToAddTitle', { system })
        this.subtitle1 = this.members.length > 0 ? this.$t('integrateUsersToAddDescription', { system }) : ''
        this.subtitle2 = ''
        this.number1Highlight = false
        this.number2Highlight = true
      } else if (this.mode === 'connect-clavo-to-integration') {
        this.title = this.$t('integrateUserTitle', { system })
        this.subtitle1 = ''
        this.subtitle2 = ''
      }
    },
    async done() {
      await this.$store.dispatch('reloadTeams')
      this.$emit('close')
    },

    updateTrialText(days) {
      if (days > 1) {
        return this.$t('duringthetrialIntro') + ' ' + this.$tc('duringthetrial', 2, { count: days, members: this.texts().maxMembersFree })
        // } else if (days > 0) {
        //   return this.$tc('duringthetrial', 1, { count: days, members: this.texts().maxMembersFree })
      } else if (days < 0) {
        return this.$t('youAreOnFreePlanUpTo5People')
      } else {
        return this.$t('duringthetrialIntro') + ' ' + this.$tc('duringthetrial', 1, { count: days, members: this.texts().maxMembersFree })
        // return this.$tc('daysleft', 0)
      }
    },
    async linktoUpgradeOptions() {
      EventBus.$emit('show-upgrade-plan', {
        teamId: this.team.teamId,
        plan: 'free',
        isTrial: true,
      })
    },
    async invite() {
      this.$store.commit('setShowProgressBar', true)
      if (process.env.IS_TESTING_SERVER) {
        await Parse.Cloud.run('setTestingHostAndPort', { host: location.protocol + '//' + location.host }, {})
      }

      for (var i = 0; i < this.emails.length; i++)
        if (this.emails[i] !== '') {
          let res = await this.addTeamMember(this.emails[i], this.teamId, null, '')
          if (res.status !== 'ok') this.showServerError(res)
        }

      this.$store.commit('setShowProgressBar', false)
      this.stage = 'done'
      await this.$store.dispatch('reloadTeams')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-content {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  .message {
    color: $black;
    font-size: $font-size-paragraph;
    line-height: 1.33em;
    background: $athens-gray;
    padding: 24px 30px;
    max-width: 580px;
    margin-bottom: 12px;
    @include respond-below(sm) {
      width: 94%;
      max-width: none;
    }
  }
  .steps {
    text-align: center;
    height: 36px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    div {
      font-family: $bold;
      margin-right: 10px;
    }
    .text-blue {
      width: 36px;
      height: 36px;
      background-color: $blue;
      color: $white;
    }
    .text-faded {
      width: 36px;
      height: 36px;
      background-color: #dae2eb;
      color: $white;
    }
  }
  .integration-connect-users {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 48px;
    margin-bottom: 24px;
    margin-top: -12px;
    background: url('~@/assets/_desktop/_settings/_icons/arrow-gray-right-XL.svg') no-repeat center 34px;
    & > div {
      flex: 1;
    }
    & :deep(p.field-description) {
      color: $black;
      font-size: 16px;
    }
    & :deep(p.field-title) {
      color: $black;
      font-size: 18px;
    }
    label {
      @include label;
      display: block;
      margin-bottom: 8px;
    }
  }
  ::v-deep .email-wrapper {
    max-height: 320px;
  }
}

section {
  display: flex;
  flex-direction: column;
  //margin: 10px 105px 30px 105px;
  //width: 63%;
  @include respond-below(sm) {
    width: 100%;
    margin: 10px 0 30px 0;
  }



  .description {
    color: $black;
    font-size: $font-size-paragraph;
    line-height: 1.33em;
    margin-bottom: 30px;
    margin-top: -12px;

    a {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    .subtitle2 {
      margin-top: 20px;
    }
  }

  .invite {
    .invite-person {
      margin-bottom: 25px;
      .invite-email {
        display: flex;
        img.delete {
          cursor: pointer;
          margin-left: 10px;
          margin-top: 5px;
        }
      }
    }
    p.vmiddle {
      display: flex;
      align-items: center;
      img {
        width: 20px;
      }
      a.with-images {
        display: inline-flex;
        align-items: center;
      }
    }
  }
}
</style>
